export default function WhyFasterSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-12">
          Why We Renew Passports Faster Than the Post Office or FedEx
        </h2>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="flex-1">
            <p className="text-gray-700 leading-relaxed mb-4">
              The reason Fast Passport Center can renew your passport so much faster isn't magic — it's access. As a registered U.S. Department of State Hand Carry courier, our couriers physically walk your renewal application into the passport agency every single business day using reserved submission slots.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              The post office puts your application in a mail queue. FedEx Office sends it to a middleman who sends it to a courier like us — after taking their cut. When you come to Fast Passport Center directly, your application goes straight to the agency the next business day. No mail delays. No middlemen. No queue.
            </p>
            <a
              href="https://fastpassportcenter.com/checkout/?passport=passport-renewal"
              className="whitespace-nowrap inline-flex items-center gap-2 mt-4 px-7 py-3 bg-[#C8A951] hover:bg-[#b8942e] text-[#1B4D3E] font-bold text-base rounded-md transition-colors cursor-pointer"
            >
              <i className="ri-rocket-line"></i>
              Start My Fast Renewal
            </a>
          </div>

          <div className="flex-1 bg-[#f0f9f4] border border-green-200 rounded-lg p-6 md:p-8">
            <h3 className="text-lg font-bold text-[#1B4D3E] mb-5">What You Get With Fast Passport Center:</h3>
            <ul className="space-y-3.5">
              {[
                "Reserved daily agency submission slots",
                "Expert document review — catches errors before submission",
                "No office visit required for eligible renewals",
                "Overnight FedEx return delivery",
                "Real-time tracking dashboard",
                "U.S.-based support team — real humans",
                "20–80% less than FedEx Office or Staples",
                "A+ BBB, 20+ years registered",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-gray-800">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-[#1B4D3E] flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-white text-xs"></i>
                  </span>
                  <span className="text-sm md:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}